import * as D3Array from 'd3-array'

export function xDomain(props, stack, horizonal) {
  const {
    data,
    chartSeries,
    x,
    xScale,
    xDomain
  } = props;

  if(xDomain)
    return xDomain;

  if(!horizonal) {
    if(xScale === 'ordinal') {
      return data.map((d) => { return x(d); });
    }else {
      return D3Array.extent(data, (d) => { return x(d); });
    }
  }else {
    if(stack) {
      // stack
      let max = 0;
      let min = 0;

      data.forEach((d) => {
        let totalTop = 0;
        let totalBottom = 0;

        chartSeries.forEach((sd) => {
          let field = sd.field;

          if(d[field] > 0) {
            totalTop += x(d[field]);
          }else if (d[field] < 0) {
            totalBottom += x(d[field]);
          }
        })

        if(totalTop > max) max = totalTop;
        if(totalBottom < min) min = totalBottom;
      })

      return [min, max];
    }else {
      // not stack, single
      let domainArr = chartSeries.map((d) => {
        let field = d.field;
        let extent = D3Array.extent(data, (dt) => { return x(dt[field]); });

        return extent;
      })

      return D3Array.extent([].concat.apply([], domainArr));
    }
  }
}
